export const sortArray = (a, b, param, order) => {
    const sorting = {
        ASC: 1,
        DESC: -1,
    };
    let sort = order.toUpperCase();

    if (a[param] > b[param]) {
        return sorting[sort];
    }
    if (a[param] < b[param]) {
        return -sorting[sort];
    }
    // a must be equal to b
    return 0;
};

export const getDashFiltered = (el) => {
    let sortedEl = [];
    el.itens.map((dash) => sortedEl.push(dash));
    sortedEl = sortedEl.sort((a, b) => sortArray(a, b, 'valor', 'DESC'));
    sortedEl = sortedEl.slice(0, 3);
    return sortedEl.sort((a, b) => sortArray(a, b, 'valor', 'ASC'));
};

export function removeEmpty(obj, dontRemoveThis = []) {
    return Object.entries(obj)
        .filter(([key, value]) => {
            if (dontRemoveThis.includes(key)) {
                return true;
            }
            if (typeof value === 'object' && value !== null) {
                const nested = removeEmpty(value, dontRemoveThis);
                return Object.keys(nested).length !== 0;
            }
            return value !== '' && value !== null && value !== undefined;
        })
        .reduce((acc, [key, value]) => {
            return {...acc, [key]: value};
        }, {});
}

export const handleToggleProperty = (prevState, property, value) => {
    return prevState[property] === value ?
        (({[property]: removedProp, ...nextState}) => nextState)(prevState) :
        {...prevState, [property]: value}
}

export function toggleValueInArray(array, value) {
    const index = array.indexOf(value);
    if (index === -1) {
        return [...array, value];
    } else {
        return array.filter((item) => item !== value);
    }
}

export function toggleObjectInArray(array, objectToAddOrRemove, conditionField) {
    const index = array.findIndex((item) => item[conditionField] === objectToAddOrRemove[conditionField]);
    if (index === -1) {
        return [...array, objectToAddOrRemove];
    } else {
        return array.filter((item) => item[conditionField] !== objectToAddOrRemove[conditionField]);
    }
}


export const parseStringToJson = (text) => {
    try {
        return JSON.parse(text);
    } catch (error) {
        return text;
    }
};

export const getAllMonthsByLocale = (locale = 'pt-BR', format = 'long') => {
    const applyFormat = new Intl.DateTimeFormat(locale, {month: format}).format;
    return [...Array(12).keys()].map((m) => applyFormat(new Date(2023, m)));
};

export const onlyInputNumbers = (event) => {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
        event.preventDefault();
    }
}

export const formatInstrumentString = (str) => {
    const INSTRUMENTOS = Object.freeze({
        ORIENTACAO_TECNICA_A_DISTANCIA: 'Orientação técnica a distância',
        INFORMACAO_A_DISTANCIA: 'Informação a distância',
        CONSULTORIA: 'Consultoria',
        ORIENTACAO_TECNICA_PRESENCIAL: 'Orientação Técnica Presencial',
    });
    return INSTRUMENTOS[str];
};

export const onlyNumbers = (value) => {
    return value.replace(/[^0-9]/g, '')
}

export const formatCPF = (cpf) => {
    cpf = cpf?.replace(/[^\d]/g, "");
    return cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export const formatCNPJ = (cnpj) => {
    cnpj = cnpj?.replace(/[^\d]/g, "");
    return cnpj?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function truncateString(str, num) {
    if (!str || str?.length <= num) {
        return str
    }
    return str?.slice(0, num) + '...'
}

export function capitalizeWords(name) {
    if (!name) return;
    const words = name.replace(/\s+/g, ' ').trim().toLowerCase().split(' ');
    return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export function validarCnpj(cnpj) {
    if (!cnpj) return false;

    cnpj = cnpj?.replace(/\D/g, '');

    if (cnpj.length !== 14) {
        return false;
    }

    const digitosIguais = /^(.)\1+$/.test(cnpj);
    if (digitosIguais) {
        return false;
    }

    let soma = 0;
    let peso = 5;
    for (let i = 0; i < 12; i++) {
        soma += parseInt(cnpj.charAt(i)) * peso;
        peso = peso === 2 ? 9 : peso - 1;
    }

    let primeiroDigito = (soma % 11 < 2) ? 0 : 11 - (soma % 11);

    if (parseInt(cnpj.charAt(12)) !== primeiroDigito) {
        return false;
    }

    soma = 0;
    peso = 6;
    for (let i = 0; i < 13; i++) {
        soma += parseInt(cnpj.charAt(i)) * peso;
        peso = peso === 2 ? 9 : peso - 1;
    }
    let segundoDigito = (soma % 11 < 2) ? 0 : 11 - (soma % 11);

    return parseInt(cnpj.charAt(13)) === segundoDigito;
}

export function removeConsecutiveDuplicatesWord(inputString) {
    if (!inputString) return;
    const words = inputString.split(' ');
    const uniqueWords = [];

    for (const word of words) {
        if (!uniqueWords.includes(word)) {
            uniqueWords.push(word);
        }
    }
    return uniqueWords.join(' ');
}

export const sortByDirection = (array, property = null, direction = 'ASC') => {
    if (!array?.length) return [];

    if (!!property && !array.some(obj => obj?.hasOwnProperty(property))) {
        return array;
    }

    array.sort((a, b) => {
        const valorA = property ? a[property]?.toString() : a;
        const valorB = property ? b[property]?.toString() : b;
        const comparison = valorA?.localeCompare(valorB, undefined, { sensitivity: 'base' });
        return direction === 'DESC' ? -comparison : comparison;
    });

    return array;
};

export const sortArrayByDirection = (array, direction = 'ASC') => {
    if (!array?.length) return [];

    let sort = direction.toUpperCase();
    array.sort((a, b) => {
        const comparison = a.toString().localeCompare(b.toString(), undefined, { sensitivity: 'base' });
        return sort === 'DESC' ? -comparison : comparison;
    });
    return array;
};


export const sortArrayWithPoint = (array, property = null, direction = 'ASC') => {
    if (!array?.length) return [];

    if (property && !array.some(obj => obj?.hasOwnProperty(property))) {
        return array;
    }

    array.sort((a, b) => {
        const valorA = property ? a[property]?.toString() : a;
        const valorB = property ? b[property]?.toString() : b;

        const parseVersion = (version) => version.split('.').map(Number);

        const partsA = parseVersion(valorA);
        const partsB = parseVersion(valorB);

        for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
            const numA = partsA[i] || 0; // Se não existir, considera 0
            const numB = partsB[i] || 0;

            if (numA !== numB) {
                return direction === 'DESC' ? numB - numA : numA - numB;
            }
        }

        return 0; // Se forem iguais
    });

    return array;
};

export const formatStringArray = (value = '')  => {
    if (!value  || (typeof value) !== "string") return '';
    return value
        .replaceAll('_', ' ')
        .split(' ')
        .map((val, index) =>  index === 0 || val.length > 4 ? val.toLowerCase() : val)
        .map((val) => val.charAt(0).toUpperCase() + val.slice(1))
        .join(' ');
};

